export const apiUrls = {
  //Auth
  login: "auth/login",
  logout: "logout",
  profile: "get-profile",
  changepassword: "change-password",
  updateimage: "update-image",
  forgotpasswordsentmail: "forgot-password-sentmail",
  //coman
  departmentdropdown: "department-dropdown",
  allemployeelisting: "all-employee-listing",
  userdropdown: "user-dropdown",
  reportingmanageremployeedropdown:"reporting-manager-employee-dropdown",
  tlassigneedropdown: "tl-assignee-dropdown",
  projectallemployeedropdown: "project-all-employee-dropdown",
  departmentuser: "department-user",
  departmentteamlead: "department-teamlead",
  projecttracklist: "project-track-list",
  technologyfilter: "technology-filter",
  clientdropdown: "client-dropdown",
  projectdropdown: "project-dropdown",
  projectassigneedropdown: "project-assignee-dropdown",
  projectemployeedropdown: "project-employee-dropdown",
  tasklistings: "task-dropdown",
  trackTime: "add-trackTime",
  totaltrackTime: "total-trackTime",
  taskstatus: "task-status",
  projectstatus: "project-status",
  completemilestone: "complete-milestone",
  multipletaskcomplete: "multiple-task-complete",
  estimationstatus: "estimation-status",
  employeetasklisting: "employee-task-listing",
  teamlearningemployees: "team-learning-employees",
  //empolyee
  empolyeelist: "employee-listing",
  deleteempolyee: "delete-employee",
  updateempolyeestatus: "employee-status",
  createempolyee: "add-employee",
  updateempolyee: "edit-employee",
  updateemployeehrdetail:"update-employee-hr-detail",
  notificationlisting: "notification-listing",
  employeelistingforhr:"employee-listing-for-hr",
  //department
  departmentlist: "department-listing",
  deletdepartment: "delete-department",
  updatedepartmentstatus: "department-status",
  createdepartment: "add-department",
  updatedepartment: "edit-department",
  //technology
  technologylist: "technology-listing",
  delettechnology: "delete-technology",
  updatetechnologystatus: "technology-status",
  createtechnology: "add-technology",
  updatetechnology: "edit-technology",
  //client
  clientlist: "client-listing",
  deletclient: "delete-client",
  updateclientstatus: "client-status",
  createclient: "add-client",
  updateclient: "edit-client",
  //project
  projectlist: "project-listing",
  createproject: "add-project",
  projectupdatedetail: "project-update-detail",
  projectdetail: "project-detail",
  learningemployees: "learning-employees",
  admindashboard: "admin-dashboard",
  onholdprojects: "on-hold-projects",
  dashboardtodaytask: "dashboard-today-task",
  employeedashboard: "employee-dashboard",
  projecteditdetail: "project-edit-detail",
  taskcountlisting: "task-count-listing",
  deletedocument: "delete-document",
  addreviewrating: "add-review-rating",
  showreviewrating: "show-review-rating",
  addclientdocument: "add-client-document",
  clientdocumentlisting: "client-document-listing",
  updateclientdocument: "update-client-document",
  //milestone
  addmilestone: "add-milestone",
  updatemilestone: "update-milestone",
  projectmilestone: "project-milestone",
  //task
  addtask: "add-task",
  tasklisting: "task-listing",
  projectmilestonesum: "project-milestone-sum",
  pendingnearbymilestones: "pending-nearby-milestones",
  employeeprojecttime: "employee-project-time",
  completetasklisting: "complete-task-listing",
  addtaskcomment: "add-task-comment",
  addtaskdocuments: "add-task-documents",
  taskcommentlisting: "task-comment-listing",
  taskflaglisting: "task-flag-listing",
  taskdailytimings: "task-daily-timings",
  tasksomedetails: "task-some-details",
  taskeditdetail: "task-edit-detail",
  taskupdatedetail: "task-update-detail",
  taskdelete: "task-delete",
  employeeprojecttask: "employee-project-task",
  taskhistory: "task-history",
  addtaskbugs: "add-task-bugs",
  addtaskflag: "add-task-flag",
  deletetaskdocument: "delete-task-document",
  //add-estimation
  addestimation: "add-estimation",
  estimationlisting: "estimation-listing",
  addcomment: "add-comment",
  activitylog: "activity-log",
  employeeprojectreview: "employee-project-review",
  employeeflaggedtask: "employee-flagged-task",
  addnotes: "add-notes",
  updatenotes: "update-notes",
  noteslisting: "notes-listing",
  deletenotes: "delete-notes",
  reportingmanageremployee: "reporting-manager-employee",
  monthlyleavesummary: "monthly-leave-summary",
  companyworkinghourstoday: "company-working-hours-today",
  employeeprojecthours: "employee-project-hours",
  projectstats: "project-stats",
  projectstatsnew: "project-stats-new",
  employeeprojectstats: "employee-project-stats",
  activityfeed: "activity-feed",
  activityfeedlike: "activity-feed-like",
  addactivityfeed: "add-activity-feed",
  addprojectbudget: "add-project-budget",
  projectbudgetlisting: "project-budget-listing",
  financialprojectreport: "financial-project-report",
  paymentreminders: "milestone/payment-reminders",
  missingtrackerdates: "missing-tracker-dates",
  hrdashboard: "hr-dashboard",
  hrprojectlisting: "hr-project-listing",
  hraddproject: "hr-add-project",
  hrprojectdetail: "hr-project-edit-detail",
  hrprojectupdatedetail: "hr-project-update-detail",
  hrprojectdetails: "hr-project-detail",
  hrprojectdropdown: "hr-project-dropdown",
  hraddtask: "hr-add-task",
  hrtasklisting: "hr-task-listing",
  hrtaskeditdetail: "hr-task-edit-detail",
  hrtaskupdatedetail: "hr-task-update-detail",
  hrtaskdelete: "hr-task-delete",
  hrtasksomedetails: "hr-task-some-details",
  hrtaskstatus: "hr-task-status",
  hrprojectstatus: "hr-project-status",
  updateattendance: "update-attendance",
  deleteattendance: "delete-attendance",
  workinghoursgraph: "working-hours-graph",
  hrcompletetasklisting: "hr-complete-task-listing",
  hrtaskcommentlisting: "hr-task-comment-listing",
  addhrtaskcomment: "add-hr-task-comment",
  documentlisting: "document-listing",
  deleteDocument: "delete-document",
  unassigneddocument: "unassigned-document",
  addassigneesdocument: "add-assignees-document",
  adddocument: "add-document",
  employeeplreport: "employee-pl-report",
  employeeleavesummary: "employee-leave-summary",
  projectstatsamount: "project-stats-amount",
  hourlyratehistory: "hourly-rate-history",
  leavelisting: "leave-listing",
  employeeTodayAllocation: "team-allocation",
  managerStats: "manager-stats",
  employeeUtilizationReport: "employee-performance",
  employeePerformanceDetail: "employee-performance-detail",
  timingsReport: "timings-report",
  employeedocumentlisting: "employee-document-listing",
  getprojectinvoice: "get-project-invoice",
  downloadinvoice: "download-invoice",
  updateprojectinvoice: "update-project-invoice",
  generatepdf: "generate-pdf",
  managerStatsTotals: "manager-stats-totals",
  warningsReport: "warnings-report",
  financialYearReport: "financial-year-report",
  financialYearProjectTypeReport: "financial-year-project-type-report",
  financialYearProjectWiseReport: "financial-year-project-wise-report",
  financialYearClientWiseReport: "financial-year-client-wise-report",
  timingsReportComment: "timings-report-comment",
  sendwarning: "send-warning",
  warningslisting: "warnings-listing",
  resolvewarning: "resolve-warning",
  deletewarning: "delete-warning",
  updatewarningcategory: "update-warning-category",
  activemanageremployeelist:"active-manager-employee-list",
  updateprojectbudget:"update-project-budget",
  projectinvoicelist: "project-invoice-list",
deleteprojectinvoice: "delete-project-invoice",
allinvoiceslisting: "all-invoices-listing",
hrinvoicelist: "hr-invoice-listing",
exporthrinvoice: "hr-invoices-export",
addhrinvoice: "add-hr-invoice",
hrinvoiceeditdetail: "hr-invoice-edit-detail",
updatehrinvoice: "hr-invoice-update-detail",
deletehrinvoice: "delete-hr-invoice",
accountinglist: "invoice-account-listing",            // GET
addaccounting: "add-invoice-account",                 // POST
accountingdetail: "invoice-account-edit-detail",      // GET ?id=
updateaccounting: "invoice-account-update-detail",    // POST (id + fields)
deleteaccounting: "delete-invoice-account",           // POST (id)
downloadaccounting: "download-invoice-account", // POST (id)
leaverequestlist: "leave-request-listing",   // GET
applyleave: "apply-leave",                   // POST
leaverequestaction: "leave-request-action",  // POST
deleteleaverequest: "delete-leave-request", 
exportaccounting: "invoice-account-export",
 attendancelist: "attendance/list",
 attendancemonthly: "attendance/monthly",
 financialYearInsights: "financial-year/insights",
 exportaccountingfields: "invoice-account-export-fields",
};
